import { createAction, props } from '@ngrx/store';
import Profile from '../types/profile';

export const setProfile = createAction('[Profile] Set Profile', props<{payload: Profile}>());
